
export class SendSmsRequest {
	public verificationGuid: string;
}
